import VMS from '../VMS/VMS';
import React, { useState, useEffect } from 'react';
import { apiClient } from '../../api_actions/index';
import { useParams } from 'react-router-dom';

export default function VMSPage() {
    
    const { deployment_id, location_name, unix_timestamp_s } = useParams()
    const [VMSTimeZone, setVMSTimeZone] = useState({})
    const [VMSConfig, setVMSConfig] = useState({})
        useEffect(() => {
            async function fetchVMSConfig() {
                try {
                    const res = await apiClient.post(`/read/vmsconfig?deployment_id=${deployment_id}`);
                    var formatted = {}
                    res.data.camera_info.map((camera, camera_idx) => {
                        const hardware_type = camera.hardware_type.hardware_meta.toLowerCase();
                        formatted[hardware_type] = {}
                        camera.streams?.map((stream, stream_idx) => {
                            formatted[hardware_type][stream.name.toLowerCase()] = []
                        })
                        camera.streams?.map((stream, stream_idx) => {
                            formatted[hardware_type][stream.name.toLowerCase()].push(stream)
                        })
                    })
                    setVMSConfig(formatted)
                    setVMSTimeZone(res.data.trailer_time_zone)
                } catch (error) {
                    console.log(error);
                }
            }
            fetchVMSConfig();
        }, []);

  return (
    
    <VMS
        unix_timestamp_s={unix_timestamp_s}
        trailer_time_zone={VMSTimeZone}
        formatted_vms_config={VMSConfig}
        location_name={location_name}
    />
  );
}
